import { useTranslation } from "@impero-com/common/utils/i18n";
import { notifyRequestError } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";
import { useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { UpdateTestingProgramsErrorPayload } from "api/generated/model";
import {
    getGetTestingProgramsQueryKey,
    getGetTestingProgramsTestingProgramIdQueryKey,
    usePatchTestingProgramsTestingProgramId,
} from "api/generated/testing-programs/testing-programs";

export function useUpdateTestingProgramMutation() {
    const { t } = useTranslation();
    const client = useQueryClient();

    return usePatchTestingProgramsTestingProgramId<
        AxiosError<{ payload: UpdateTestingProgramsErrorPayload }>
    >({
        mutation: {
            onError: (
                error: AxiosError<{
                    payload: UpdateTestingProgramsErrorPayload;
                }>
            ) => {
                if (error.response?.data.payload === "duplicatedName") {
                    emitNotification(
                        "error",
                        t("TestingProgramView_Name_NotUnique")
                    );
                    client.invalidateQueries({
                        queryKey: getGetTestingProgramsQueryKey(),
                    });
                    return;
                }
                notifyRequestError(error);
            },
            onSuccess: (_data, vars) => {
                client.invalidateQueries({
                    queryKey: getGetTestingProgramsQueryKey(),
                });
                client.invalidateQueries({
                    queryKey: getGetTestingProgramsTestingProgramIdQueryKey(
                        vars.testingProgramId
                    ),
                });
            },
        },
    });
}
